import React from "react";
import styles from "./Counter.module.scss";
import CounterItem from "./CounterItem";
import {Container} from "react-bootstrap";

const countData = [
    {
        title: "КЛИЕНТОВ ФИЗИЧЕСКИХ ЛИЦ",
        count: 5500000,
    },
    {
        title: "КОНСУЛЬТАЦИЙ ПРОВЕДЕНО",
        count: 7000000,
    },
    {
        title: "КЛИЕНТОВ ЮРИДИЧЕСКИХ ЛИЦ",
        count: 450000,
    },
    {
        title: "ШТАТ СПЕЦИАЛИСТОВ",
        count: 500,
    },
]

const Counter: React.FC = () => {
    return (
        <div className={styles.counterSection}>
            <Container>
                <div className="position-relative">
                    <div className={styles.counterWrap}>
                        {countData.map((item) =>
                            <CounterItem key={item.count} {...item}/>
                        )}
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default Counter;